import { DataLakeReadableConsts } from 'dashboard-services/api/dataLake';
import TimeService from 'dashboard-services/services/TimeService';

import GroupFilter from 'components/modules/MyAccount/Lists/UserManagment/UserDetails/Body/DeletionView/StepOne/GroupFilter';

export default (() => {
  const GLOBAL_SEARCH_PREFIX = "DELETION_SEARCH"

  const USER_DELETION_MODES = {
    DELETE_ONLY: "DELETE_ONLY",
    TRANSFER_AND_DELETE: "TRANSFER_AND_DELETE"
  }

  const CATEGORIES_ELEMENTS = [
    {
      label: "GROUPS",
      uniqueIdKey: "groupId",
      columns: [
        {
          width: 50,
          columnName: "Name",
          fieldName: "name",
        },
        {
          width: 50,
          columnName: "Description",
          fieldName: "description",
        },
      ]
    },
    {
      label: "PIPELINES",
      uniqueIdKey: "id",
      columns: [
        {
          width: 40,
          columnName: "Name",
          fieldName: "name",
        },
        {
          width: 40,
          columnName: "Group",
          fieldName: "groupName",
          headerRenderer: (
            <div className="deletion__step-one__list__headers__group-filter">
              <GroupFilter/>
            </div>
          )
        },
        {
          width: 20,
          columnName: "Last modified",
          fieldName: "lastChange",
          rowRenderer: ({ definedTime, fieldValue }) => definedTime ? TimeService.getUserFormattedDate(fieldValue, definedTime) : "",
        },
      ]
    },
    {
      label: "DATA PREPS",
      uniqueIdKey: "name",
      columns: [
        {
          width: 40,
          columnName: "Name",
          fieldName: "name",
        },
        {
          width: 40,
          columnName: "Group",
          fieldName: "groupName",
          headerRenderer: (
            <div className="deletion__step-one__list__headers__group-filter">
              <GroupFilter/>
            </div>
          )
        },
        {
          width: 20,
          columnName: "Last modified",
          fieldName: "lastChange",
          rowRenderer: ({ definedTime, fieldValue }) => definedTime ? TimeService.getUserFormattedDate(fieldValue, definedTime) : "",
        },
      ]
    },
    {
      label: "INSIGHTS",
      uniqueIdKey: "fid",
      columns: [
        {
          width: 40,
          columnName: "Name",
          fieldName: "fileName",
          rowRenderer: ({ fieldValue }) => fieldValue?.replace(".json", "")
        },
        {
          width: 40,
          columnName: "Group",
          fieldName: "groupName",
          headerRenderer: (
            <div className="deletion__step-one__list__headers__group-filter">
              <GroupFilter/>
            </div>
          )
        },
        {
          width: 20,
          columnName: "Last modified",
          fieldName: "arrivalTime",
          rowRenderer: ({ definedTime, fieldValue }) => definedTime ? TimeService.getUserFormattedDate(fieldValue, definedTime) : "",
        },
      ]
    },
    {
      label: "ALL FILES",
      uniqueIdKey: "fid",
      columns: [
        {
          width: 35,
          columnName: "Name",
          fieldName: "fileName",
        },
        {
          width: 35,
          columnName: "Group",
          fieldName: "groupName",
          headerRenderer: (
            <div className="deletion__step-one__list__headers__group-filter">
              <GroupFilter/>
            </div>
          )
        },
        {
          width: 15,
          columnName: "Last modified",
          fieldName: "arrivalTime",
          rowRenderer: ({ definedTime, fieldValue }) => definedTime ? TimeService.getUserFormattedDate(fieldValue, definedTime) : "",
        },
        {
          width: 15,
          columnName: "Type",
          fieldName: "fileType",
          rowRenderer: ({ fieldValue }) => DataLakeReadableConsts.FILE_TYPES.find(f => f.value === fieldValue)?.label || fieldValue
        },
      ]
    },
  ]

  return {
    USER_DELETION_MODES,
    CATEGORIES_ELEMENTS,
    GLOBAL_SEARCH_PREFIX
  }
})()